import { render } from "./folio_signatories_modal.vue?vue&type=template&id=6fd250a2"
import script from "./folio_signatories_modal.vue?vue&type=script&lang=js"
export * from "./folio_signatories_modal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__